import { useEffect } from "react";
import { datadogRum } from "@datadog/browser-rum";
import type { Osdk } from "@osdk/client";
import type { User } from "@unruly-osdk/sdk";

/**
 * Attaches the signed-in user to the RUM session.
 *
 * Permission failures are per-account, so an unattributed session tells us a
 * 403 happened but not to whom — which is the only detail that makes it
 * diagnosable.
 */
export function useDatadogUser(user: Osdk.Instance<User> | null | undefined) {
  useEffect(() => {
    if (!user) {
      return;
    }
    datadogRum.setUser({
      id: user.id,
      email: user.email,
      name: [user.firstName, user.lastName].filter(Boolean).join(" "),
    });
  }, [user]);
}
